import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=186a9d7e&scoped=true"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186a9d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src185367243/src/bitbucket.org/iprosystems/jbg-product-catalog-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186a9d7e')) {
      api.createRecord('186a9d7e', component.options)
    } else {
      api.reload('186a9d7e', component.options)
    }
    module.hot.accept("./AlertBar.vue?vue&type=template&id=186a9d7e&scoped=true", function () {
      api.rerender('186a9d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/AlertBar.vue"
export default component.exports